const BENCHMARK = {

  id: "benchmark",
  type: "dropdown",
  props: {
    dropdownProps: {
      label: "Benchmark",
      buttonProps: {
        className: "benchmark",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "SORA", value: "SORA" },
      { label: "Fixed", value: "Fixed" },
    ]
  }

}

const COL_BENCHMARK = {

  id: "col_benchmark",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [BENCHMARK]

}

export { BENCHMARK, COL_BENCHMARK };
